import {reqWithToken} from './requestHelper';

export async function getTimetableOfRoom(params) {
    return (await reqWithToken('api/gxbooking/courseTimes',
        {
            params
        })).data;
}
